import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Committee } from './committee.model';

const axios = useAxios();

export interface CommitteeService {
  Fetch: () => Promise<AxiosResponse<Committee[]>>;
}

const Fetch = (): Promise<AxiosResponse<Committee[]>> =>
  axios.Get<Committee[]>('api/committees');

export default { Fetch } as CommitteeService;
